var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99907 1.66309C13.374 1.66309 16.1296 4.32538 16.2456 7.70397L16.2491 7.91308V11.3273L17.3991 13.9573C17.4566 14.0888 17.4863 14.2309 17.4863 14.3746C17.4863 14.9498 17.02 15.4163 16.4446 15.4163L12.4991 15.4175C12.4991 16.7982 11.3798 17.9175 9.99907 17.9175C8.66765 17.9175 7.57936 16.8767 7.50332 15.5643L7.4987 15.4156L3.56147 15.4163C3.41868 15.4163 3.27743 15.3868 3.14646 15.33C2.61879 15.1008 2.37683 14.4873 2.60603 13.9596L3.74908 11.328V7.913C3.74958 4.45068 6.54248 1.66309 9.99907 1.66309ZM11.2487 15.4156L8.74907 15.4175C8.74907 16.1078 9.30873 16.6675 9.99907 16.6675C10.6488 16.6675 11.1828 16.1718 11.2433 15.5378L11.2487 15.4156ZM9.99907 2.91309C7.23228 2.91309 4.99948 5.14163 4.99908 7.91308V11.5878L3.87909 14.1663H16.1262L14.9991 11.5886L14.9992 7.9238L14.9961 7.73613C14.9035 5.04157 12.7004 2.91309 9.99907 2.91309Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.51d3ce91c94ee242e46b34332a2907ba.svg";
export { ForwardRef as ReactComponent };